// import TopNav from '../components/topnav';
// import React, { useEffect, useState } from 'react';
// import Spinner from '../components/spinner';
// import { useCookies } from 'react-cookie';
// import PowerBIReport from '../components/report';
// import { reportApi } from '../api/serverApi';
// import { getValidAccessToken } from '../services/garphService';
// import { useMsal } from '@azure/msal-react';
// import * as microsoftTeams from '@microsoft/teams-js';

// const DashBoards = () => {
//   const [dimensions, setDimensions] = useState({ width: '100%', height: '500px' });
//   const { instance, accounts } = useMsal();
//   // const handleResize = (e) => {
//   //   const { name, value } = e.target;
//   //   setDimensions(prev => ({ ...prev, [name]: value }));
//   // };
//   const [cookies] = useCookies([
//     'email',
//     'name',
//     'permissions',
//     'accessToken',
//   ]);
//   const [loading, setLoading] = useState(false);
//   const [accessToken, setAccessToken] = useState(null);
//   const [url, setUrl] = useState('');
//   const role = cookies.permissions;
 
//   // ✅ Different report IDs based on role
//   const reportId = {
//     report_id:
//        role === "Admin"
//         ? "2f35bb7f-bb37-4114-9ca6-9257f296f4ae"
//         : "ba6d0014-1cc3-41a7-a322-0789e931dad4",
//   };

//   const isInTeams = () => {
//     try {
//       return window.parent !== window.self;
//     } catch {
//       return false;
//     }
//   };

//   useEffect(() => {
//     const fetchEmbedInfo = async () => {
//       try {
//         let token;
//         if (isInTeams()) {
//           token = await new Promise((resolve, reject) => {
//             microsoftTeams.authentication.getAuthToken({
//               successCallback: resolve,
//               failureCallback: reject,
//               resources: ['https://graph.microsoft.com'],
//             });
//           });
//         } else {
//           token = await getValidAccessToken(instance, accounts);
//         }

//         const response = await reportApi(reportId, token);
//         const embedInfo = response.data?.embed_info;

//         if (!embedInfo) {
//           console.error('❌ embed_info missing in response');
//           setLoading(false);
//           return;
//         }

//         setAccessToken(embedInfo.accessToken);

//         if (Array.isArray(embedInfo.reportConfig) && embedInfo.reportConfig.length > 0) {
//           setUrl(embedInfo.reportConfig[0].embedUrl);
//         } else {
//           console.error('❌ reportConfig is empty or not an array');
//           setUrl(null);
//         }
//       } catch (error) {
//         console.error('❌ Error fetching embed info:', error.response?.data || error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchEmbedInfo();
//   }, [cookies, role]); //  added role to dependencies

//   if (accessToken !== null && url !== '' && !loading)
//     return (
//       <div>
//         <TopNav />
//         <div className="py-4 bg-white">
//           <div className="h-full lg:h-[1024px] flex flex-col mx-auto px-8 py-4">
//             <div style={{ width: dimensions.width, height: dimensions.height }}>
//               <PowerBIReport
//                 embedToken={accessToken}
//                 embedUrl={url}
//                 reportId={reportId.report_id}
//                 width={dimensions.width}
//                 height={dimensions.height}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   else {
//     return (
//       <div><Spinner /></div>
//     );
//   }
// };

// export default DashBoards;




// import TopNav from '../components/topnav';
// import React, { useEffect, useState } from 'react';
// import Spinner from '../components/spinner';
// import { useCookies } from 'react-cookie';
// import PowerBIReport from '../components/report';
// import { reportApi } from '../api/serverApi';
// import { getValidAccessToken } from '../services/garphService';
// import { useMsal } from '@azure/msal-react';
// import * as microsoftTeams from '@microsoft/teams-js';

// const DashBoards = () => {
//   const [dimensions] = useState({
//     width: '100%',
//     height: '500px',
//   });

//   const { instance, accounts } = useMsal();

//   const [cookies] = useCookies([
//     'email',
//     'name',
//     'permissions',
//     'accessToken',
//   ]);

//   const [loading, setLoading] = useState(true);
//   const [accessToken, setAccessToken] = useState(null);
//   const [url, setUrl] = useState('');

//   // ---------------------------------------------------------
//   // USER ROLE
//   // ---------------------------------------------------------

//   const role = cookies.permissions;

//   console.log('User Role:', role);

//   // ---------------------------------------------------------
//   // POWER BI WORKSPACE
//   // ---------------------------------------------------------

//   const WORKSPACE_ID = '5773f953-1086-4d51-9879-8cfcd557ff3b';

//   // ---------------------------------------------------------
//   // POWER BI REPORT IDs
//   // ---------------------------------------------------------

//   const REPORT_IDS = {
//     Admin: 'f1b021b2-cdaa-4610-b457-4a8de874617c',

//     'State Admin and Location Admin':
//       '7ef7d347-86cb-445d-b07b-b7f17c6d9c2b',
  
      

//     'SPOC and End User':
//       'ba6d0014-1cc3-41a7-a322-0789e931dad4',
//   };

//   // ---------------------------------------------------------
//   // GET REPORT ID BASED ON ROLE
//   // ---------------------------------------------------------

//   const selectedReportId =
//     REPORT_IDS[role] || REPORT_IDS['SPOC and End User'];

//   console.log('Selected Report ID:', selectedReportId);

//   // ---------------------------------------------------------
//   // REPORT OBJECT
//   // ---------------------------------------------------------

//   const reportId = {
//     report_id: selectedReportId,
//   };

//   // ---------------------------------------------------------
//   // DETECT MICROSOFT TEAMS
//   // ---------------------------------------------------------

//   const isInTeams = () => {
//     try {
//       return window.parent !== window.self;
//     } catch (error) {
//       return false;
//     }
//   };

//   // ---------------------------------------------------------
//   // FETCH POWER BI EMBED INFORMATION
//   // ---------------------------------------------------------

//   useEffect(() => {
//     const fetchEmbedInfo = async () => {
//       setLoading(true);

//       try {
//         let token;

//         // -----------------------------------------------------
//         // GET TOKEN FROM TEAMS
//         // -----------------------------------------------------

//         if (isInTeams()) {
//           console.log('Running inside Microsoft Teams');

//           token = await new Promise((resolve, reject) => {
//             microsoftTeams.authentication.getAuthToken({
//               successCallback: resolve,
//               failureCallback: reject,
//               resources: ['https://graph.microsoft.com'],
//             });
//           });
//         }

//         // -----------------------------------------------------
//         // GET TOKEN FROM AZURE AD / MSAL
//         // -----------------------------------------------------

//         else {
//           console.log('Running outside Microsoft Teams');

//           token = await getValidAccessToken(
//             instance,
//             accounts
//           );
//         }

//         console.log('Token received');

//         // -----------------------------------------------------
//         // CALL BACKEND API
//         // -----------------------------------------------------

//         const response = await reportApi(
//           reportId,
//           token
//         );

//         console.log(
//           'Power BI API Response:',
//           response.data
//         );

//         // -----------------------------------------------------
//         // GET EMBED INFORMATION
//         // -----------------------------------------------------

//         const embedInfo =
//           response.data?.embed_info;

//         if (!embedInfo) {
//           console.error(
//             '❌ embed_info missing in response'
//           );

//           setAccessToken(null);
//           setUrl('');

//           return;
//         }

//         // -----------------------------------------------------
//         // SET EMBED TOKEN
//         // -----------------------------------------------------

//         if (embedInfo.accessToken) {
//           setAccessToken(
//             embedInfo.accessToken
//           );
//         } else {
//           console.error(
//             '❌ Power BI access token missing'
//           );

//           setAccessToken(null);
//         }

//         // -----------------------------------------------------
//         // SET EMBED URL
//         // -----------------------------------------------------

//         if (
//           Array.isArray(
//             embedInfo.reportConfig
//           ) &&
//           embedInfo.reportConfig.length > 0
//         ) {
//           const embedUrl =
//             embedInfo.reportConfig[0]
//               ?.embedUrl;

//           if (embedUrl) {
//             setUrl(embedUrl);

//             console.log(
//               'Power BI Embed URL:',
//               embedUrl
//             );
//           } else {
//             console.error(
//               '❌ embedUrl missing'
//             );

//             setUrl('');
//           }
//         } else {
//           console.error(
//             '❌ reportConfig is empty or invalid'
//           );

//           setUrl('');
//         }
//       } catch (error) {
//         console.error(
//           '❌ Error fetching Power BI embed info:',
//           error?.response?.data ||
//             error?.message ||
//             error
//         );

//         setAccessToken(null);
//         setUrl('');
//       } finally {
//         setLoading(false);
//       }
//     };

//     // ---------------------------------------------------------
//     // ONLY FETCH WHEN ROLE IS AVAILABLE
//     // ---------------------------------------------------------

//     if (role) {
//       fetchEmbedInfo();
//     } else {
//       console.warn(
//         '⚠️ User role is not available'
//       );

//       setLoading(false);
//     }

//   }, [instance, accounts, role]);

//   // ---------------------------------------------------------
//   // LOADING SCREEN
//   // ---------------------------------------------------------

//   if (loading) {
//     return (
//       <div>
//         <Spinner />
//       </div>
//     );
//   }

//   // ---------------------------------------------------------
//   // ERROR SCREEN
//   // ---------------------------------------------------------

//   if (!accessToken || !url) {
//     return (
//       <div>
//         <TopNav />

//         <div
//           className="flex items-center justify-center"
//           style={{
//             height: '500px',
//           }}
//         >
//           <div className="text-center">
//             <h2 className="text-xl font-semibold text-red-600">
//               Unable to load dashboard
//             </h2>

//             <p className="mt-2 text-gray-600">
//               No Power BI report configuration
//               was found for your role.
//             </p>

//             <p className="mt-2 text-sm text-gray-500">
//               Role: {role || 'Unknown'}
//             </p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ---------------------------------------------------------
//   // POWER BI DASHBOARD
//   // ---------------------------------------------------------

//   return (
//     <div>
//       <TopNav />

//       <div className="py-4 bg-white">
//         <div
//           className="
//             h-full
//             lg:h-[1024px]
//             flex
//             flex-col
//             mx-auto
//             px-8
//             py-4
//           "
//         >
//           <div
//             style={{
//               width: dimensions.width,
//               height: dimensions.height,
//             }}
//           >
//             <PowerBIReport
//               embedToken={accessToken}
//               embedUrl={url}
//               reportId={reportId.report_id}
//               width={dimensions.width}
//               height={dimensions.height}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DashBoards;









import TopNav from '../components/topnav';
import React, { useEffect, useState } from 'react';
import Spinner from '../components/spinner';
import { useCookies } from 'react-cookie';
import PowerBIReport from '../components/report';
import { reportApi } from '../api/serverApi';
import { getValidAccessToken } from '../services/garphService';
import { useMsal } from '@azure/msal-react';
import * as microsoftTeams from '@microsoft/teams-js';

const DashBoards = () => {
  const [dimensions] = useState({
    width: '100%',
    height: '500px',
  });

  const { instance, accounts } = useMsal();

  const [cookies] = useCookies([
    'email',
    'name',
    'permissions',
    'accessToken',
  ]);

  const [loading, setLoading] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [url, setUrl] = useState('');

  // =========================================================
  // USER PERMISSION
  // =========================================================

  const role = cookies.permissions;

  const normalizedRole =
    typeof role === 'string'
      ? role.trim().replace(/\s+/g, ' ')
      : '';

  // =========================================================
  // PERMISSION DEBUG
  // =========================================================

  console.log('==========================================');
  console.log('POWER BI PERMISSION DEBUG');
  console.log('==========================================');

  console.log(
    'Raw permissions:',
    cookies.permissions
  );

  console.log(
    'Permissions type:',
    typeof cookies.permissions
  );

  console.log(
    'Permissions JSON:',
    JSON.stringify(cookies.permissions)
  );

  console.log(
    'Normalized role:',
    normalizedRole
  );

  console.log(
    'Normalized role JSON:',
    JSON.stringify(normalizedRole)
  );

  // =========================================================
  // POWER BI REPORT IDS
  // =========================================================

  const REPORT_IDS = {
    Admin:
      'f1b021b2-cdaa-4610-b457-4a8de874617c',

    'State Admin':
      '7ef7d347-86cb-445d-b07b-b7f17c6d9c2b',

    'Location Admin':
      '7ef7d347-86cb-445d-b07b-b7f17c6d9c2b',

    SPOC:
      'ba6d0014-1cc3-41a7-a322-0789e931dad4',

    'End User':
      'ba6d0014-1cc3-41a7-a322-0789e931dad4',
  };

  // =========================================================
  // GET REPORT ID BASED ON ROLE
  // =========================================================

  let selectedReportId = null;

  if (normalizedRole === 'Admin') {
    selectedReportId = REPORT_IDS.Admin;

    console.log('✅ Permission matched: Admin');
  }

  else if (normalizedRole === 'State Admin') {
    selectedReportId = REPORT_IDS['State Admin'];

    console.log(
      '✅ Permission matched: State Admin'
    );
  }

  else if (normalizedRole === 'Location Admin') {
    selectedReportId = REPORT_IDS['Location Admin'];

    console.log(
      '✅ Permission matched: Location Admin'
    );
  }

  else if (normalizedRole === 'Spoc') {
    selectedReportId = REPORT_IDS.SPOC;

    console.log(
      '✅ Permission matched: SPOC'
    );
  }

  else if (normalizedRole === 'End User') {
    selectedReportId = REPORT_IDS['End User'];

    console.log(
      '✅ Permission matched: End User'
    );
  }

  else {
    console.error(
      '❌ UNKNOWN PERMISSION:',
      JSON.stringify(normalizedRole)
    );
  }

  // =========================================================
  // FINAL REPORT DEBUG
  // =========================================================

  console.log(
    'Selected Report ID:',
    selectedReportId
  );

  console.log('==========================================');

  // =========================================================
  // REPORT OBJECT
  // =========================================================

  const reportId = {
    report_id: selectedReportId,
  };

  // =========================================================
  // DETECT MICROSOFT TEAMS
  // =========================================================

  const isInTeams = () => {
    try {
      return window.parent !== window.self;
    } catch {
      return false;
    }
  };

  // =========================================================
  // FETCH POWER BI EMBED INFORMATION
  // =========================================================

  useEffect(() => {
    const fetchEmbedInfo = async () => {
      try {
        setLoading(true);

        console.log(
          '=========================================='
        );

        console.log(
          'FETCHING POWER BI REPORT'
        );

        console.log(
          'Permission:',
          JSON.stringify(normalizedRole)
        );

        console.log(
          'Selected Report ID:',
          selectedReportId
        );

        // -----------------------------------------------------
        // CHECK REPORT ID
        // -----------------------------------------------------

        if (!selectedReportId) {
          console.error(
            '❌ No report ID found for permission:',
            JSON.stringify(normalizedRole)
          );

          setAccessToken(null);
          setUrl('');

          return;
        }

        // -----------------------------------------------------
        // GET TOKEN
        // -----------------------------------------------------

        let token;

        // -----------------------------------------------------
        // TOKEN FROM MICROSOFT TEAMS
        // -----------------------------------------------------

        if (isInTeams()) {
          console.log(
            'Running inside Microsoft Teams'
          );

          token = await new Promise(
            (resolve, reject) => {
              microsoftTeams.authentication.getAuthToken({
                successCallback: resolve,
                failureCallback: reject,
                resources: [
                  'https://graph.microsoft.com',
                ],
              });
            }
          );
        }

        // -----------------------------------------------------
        // TOKEN FROM AZURE AD / MSAL
        // -----------------------------------------------------

        else {
          console.log(
            'Running outside Microsoft Teams'
          );

          token = await getValidAccessToken(
            instance,
            accounts
          );
        }

        console.log(
          'Token received:',
          !!token
        );

        // -----------------------------------------------------
        // CALL BACKEND API
        // -----------------------------------------------------

        console.log(
          'Calling reportApi with:',
          reportId
        );

        const response = await reportApi(
          reportId,
          token
        );

        // -----------------------------------------------------
        // BACKEND RESPONSE
        // -----------------------------------------------------

        console.log(
          'Power BI API Response:',
          response.data
        );

        // -----------------------------------------------------
        // GET EMBED INFO
        // -----------------------------------------------------

        const embedInfo =
          response.data?.embed_info;

        if (!embedInfo) {
          console.error(
            '❌ embed_info missing in response'
          );

          setLoading(false);
          return;
        }

        // -----------------------------------------------------
        // SET ACCESS TOKEN
        // -----------------------------------------------------

        setAccessToken(
          embedInfo.accessToken
        );

        console.log(
          'Power BI access token received:',
          !!embedInfo.accessToken
        );

        // -----------------------------------------------------
        // SET EMBED URL
        // -----------------------------------------------------

        if (
          Array.isArray(
            embedInfo.reportConfig
          ) &&
          embedInfo.reportConfig.length > 0
        ) {
          const embedUrl =
            embedInfo.reportConfig[0]?.embedUrl;

          if (embedUrl) {
            setUrl(embedUrl);

            console.log(
              'Power BI Embed URL:',
              embedUrl
            );
          } else {
            console.error(
              '❌ embedUrl missing'
            );

            setUrl('');
          }
        } else {
          console.error(
            '❌ reportConfig is empty or not an array'
          );

          setUrl('');
        }
      } catch (error) {
        console.error(
          '❌ Error fetching embed info:',
          error?.response?.data ||
            error?.message ||
            error
        );

        setAccessToken(null);
        setUrl('');
      } finally {
        setLoading(false);

        console.log(
          '=========================================='
        );
      }
    };

    // ---------------------------------------------------------
    // FETCH ONLY WHEN ROLE IS AVAILABLE
    // ---------------------------------------------------------

    if (normalizedRole) {
      fetchEmbedInfo();
    } else {
      console.warn(
        '⚠️ User permission is not available'
      );

      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    instance,
    accounts,
    normalizedRole,
  ]);

  // =========================================================
  // LOADING SCREEN
  // =========================================================

  if (accessToken !== null && url !== '' && !loading) {
    return (
      <div>
        <TopNav />

        <div className="py-4 bg-white">
          <div className="h-full lg:h-[1024px] flex flex-col mx-auto px-8 py-4">
            <div
              style={{
                width: dimensions.width,
                height: dimensions.height,
              }}
            >
              <PowerBIReport
                embedToken={accessToken}
                embedUrl={url}
                reportId={reportId.report_id}
                width={dimensions.width}
                height={dimensions.height}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // =========================================================
  // ERROR / LOADING
  // =========================================================

  return (
    <div>
      <Spinner />
    </div>
  );
};

export default DashBoards;